import { useEffect, useState } from "react";
import Notification from "../../../../components/toast";
import { useForm } from "react-hook-form";
import reqConfiguracaoCatalogo from "../../../../services/reqMultiTenant/reqConfiguracaoCatalogo";
import { getReturnUpdated } from "../../../../util/libObject";

export const IndexHook = () => {
	const {
		register,
		handleSubmit,
		setValue,
		watch,
		formState: { errors, isSubmitting },
		control,
	} = useForm({
		mode: "onSubmit",
		defaultValues: {
			id_configuracao_catalogo: 0,
			theme: "blue",
			entrega_transportadora: false,
			entrega_local: false,
			complementos: false,
			validar_estoque: false,
			titulo_seo: "",
			descricao_seo: "",
			pgto_pix: true,
			pgto_credito: true,
			pgto_boleto: false,
			pgto_dinheiro: true,
		},
	});

	const [loading, setLoading] = useState(true);

	const fetchCatalogData = async () => {
		try {
			setLoading(true);
			const response = await reqConfiguracaoCatalogo.listByEmpresa();
			const catalogData = getReturnUpdated(response);

			if (catalogData && catalogData.id_configuracao_catalogo) {
				Object.keys(catalogData).forEach((field) => {
					setValue(field, catalogData[field]);
				});
			}
		} catch (error) {
			// Ignora se não houver configuração prévia
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchCatalogData();
	}, []);

	const handleOnSubmit = async (data) => {
		try {
			const res = await reqConfiguracaoCatalogo.insertUpdate(data);
			Notification.showToast({ message: "Configurações do catálogo salvas.", type: "success" });
		} catch (error) {
			Notification.showToast({ message: error.message || "Erro desconhecido ao salvar", type: "error" });
		}
	};

	return {
		register,
		handleSubmit,
		control,
		errors,
		isSubmitting,
		loading,
		watch,
		setValue,
		handleOnSubmit,
	};
};
